<script>
    // import ImgUpload from './ImgUpload.svelte';
    import {Col, Container, Row, Spinner, Modal} from 'sveltestrap';
    import {onMount} from 'svelte';

	import * as tf from '@tensorflow/tfjs';
	// import {loadGraphModel} from '@tensorflow/tfjs-converter';

    let MSIZE = 'medium';
    // let MSIZE = 'large';
    export let W = 256;
    export let H = 256;
    let expW = 256;
    let expH = 256;
    let ENC_URL;
    let DEC_URL;

    let done = true;
    let changingStyles = false;

    if (MSIZE == 'large') {
        W = 512;
        H = 512;
        ENC_URL = 'https://raw.githubusercontent.com/mkirchler/style-transfer-models/master/enc_large/model.json';
        DEC_URL = 'https://raw.githubusercontent.com/mkirchler/style-transfer-models/master/dec_large/model.json';
        // ENC_URL = 'models/enc_large/model.json';
        // DEC_URL = 'models/dec_large/model.json';
    } else {
        W = 256;
        H = 256;
        ENC_URL = 'https://raw.githubusercontent.com/mkirchler/style-transfer-models/master/enc/model.json';
        DEC_URL = 'https://raw.githubusercontent.com/mkirchler/style-transfer-models/master/dec/model.json';
        // ENC_URL = 'models/enc/model.json';
        // DEC_URL = 'models/dec/model.json';
    }

    let originalH = -1;
    let originalW = -1;



    let videoPlaying = false;
    function toggleVid() {
        if (videoPlaying) {
            globalStream.getTracks().forEach(track => track.stop());
        } else {
            setupWebcam();
        }

        videoPlaying = !videoPlaying;
    }
    function restoreCrop(imgTensor) {
        imgTensor = imgTensor.reshape(imgTensor.shape.slice(1));
        // console.log(imgTensor.shape);
        if (originalH > 0) {
            let maxSize = Math.max(originalH, originalW);
            // console.log(maxSize);
            imgTensor = tf.image.resizeBilinear(imgTensor, [maxSize, maxSize]);
            let hPad = (maxSize - originalH) / 2;
            let wPad = (maxSize - originalW) / 2;
            imgTensor = imgTensor.slice([hPad, wPad], [originalH, originalW]);
        }
        return imgTensor;


    }
    function downloadImage() {
        let link = document.createElement('a');
        link.download = 'file.png';
        link.href = document.getElementById('canvas').toDataURL();
        link.click();
    }

    function cropResize(imgTensor) {
        // console.log('in cropResize');
        // console.log(imgTensor.shape);
        originalH = imgTensor.shape[0];
        originalW = imgTensor.shape[1];
        let maxSize = Math.max(originalH, originalW);
        let hPad = (maxSize - originalH) / 2;
        let wPad = (maxSize - originalW) / 2;
        // console.log(hPad, wPad, maxSize);
        let paddedTensor = tf.pad(imgTensor, [[hPad, hPad], [wPad, wPad], [0, 0]]);
        paddedTensor = tf.image.resizeBilinear(paddedTensor, [H, W]);
        imgTensor.dispose();
        // console.log(paddedTensor);
        // console.log(paddedTensor.shape);
        // console.log('end cropResize');
        return paddedTensor;
    }
    // let defaultContent = './imgs/avril_cropped.jpg';
    let defaultContent = 'https://raw.githubusercontent.com/mkirchler/style-transfer-models/master/imgs/avril_cropped.jpg';
    async function updateInput(event) {
        const [file] = document.getElementById("content-input").files;
        // console.log(file);

        let imgInput = document.getElementById('img-input');
        if (file) {
            imgInput.src = URL.createObjectURL(file);
        }
        imgInput.onload = () => {
            URL.revokeObjectURL(imgInput.src);
            updateContent();
        }
    }
    async function updateContent() {

        content_feat = tf.tidy(() => {
            let content = tf.browser
                            .fromPixels(document.getElementById('img-input'))
                            .reverse(-1);
            content = cropResize(content);
            content = content.reshape([1, W, H, 3])
                            .cast('float32');
            // content = cropResize(content);
            // console.log(content);
            content_feat = encoder.predict(content);
            return content_feat;
        })

    }
    let video;
    let globalStream;

    let encoder, decoder;
    // let content, style;
    let stylized;

    let style_feat;
    let content_feat;
    let selected_style = 0;

    // async function exportStyles() {
    //     for (let i=0; i<STYLES.length; i++) {
    //         console.log(i);
    //         await selectStyle(i);
    //         let saveTensor = {data: await style_feat.dataSync(), shape: style_feat.shape};
    //         console.log(saveTensor);
    //         let a = document.createElement("a");
    //         var file = new Blob([JSON.stringify(saveTensor)], {type: 'text/plain'});
    //         a.href = URL.createObjectURL(file);
    //         a.download = 'style-' + i + '.txt';
    //         a.click();
    //         return;
    //     }
    // }
    const STYLES = [
        'https://raw.githubusercontent.com/mkirchler/style-transfer-models/master/imgs/styles/ashville_cropped.jpg',
        'https://raw.githubusercontent.com/mkirchler/style-transfer-models/master/imgs/styles/en_campo_gris_cropped.jpg',
        'https://raw.githubusercontent.com/mkirchler/style-transfer-models/master/imgs/styles/goeritz_cropped.jpg',
        'https://raw.githubusercontent.com/mkirchler/style-transfer-models/master/imgs/styles/impronte_d_artista_cropped.jpg',
        'https://raw.githubusercontent.com/mkirchler/style-transfer-models/master/imgs/styles/sketch_cropped.png',
        'https://raw.githubusercontent.com/mkirchler/style-transfer-models/master/imgs/styles/woman_with_hat_matisse_cropped.jpg',
        'https://raw.githubusercontent.com/mkirchler/style-transfer-models/master/imgs/styles/81914.jpg',
        'https://raw.githubusercontent.com/mkirchler/style-transfer-models/master/imgs/styles/frida-kahlo.jpg',
        'https://raw.githubusercontent.com/mkirchler/style-transfer-models/master/imgs/styles/mona-lisa.jpg',
        'https://raw.githubusercontent.com/mkirchler/style-transfer-models/master/imgs/styles/monet.jpg',
        'https://raw.githubusercontent.com/mkirchler/style-transfer-models/master/imgs/styles/style2.jpg',
        'https://raw.githubusercontent.com/mkirchler/style-transfer-models/master/imgs/styles/style3.jpg',
    ]

    async function loadModels() {
		encoder = await tf.loadGraphModel(
            ENC_URL,
            // {onProgress: function(frac){ console.log(frac);}}
            );
		decoder = await tf.loadGraphModel(
            DEC_URL,
            // {onProgress: function(frac){ console.log(frac);}}
            );
    }
    async function transferStyle() {
        // const cont_feat = encoder.predict(content);
        // const style_feat = encoder.predict(style);
        // console.log('in transferStyle', content_feat.shape, style_feat.shape);
        const inp = tf.concat([content_feat, style_feat], 0);

        stylized = decoder.predict(inp);
        inp.dispose();
        stylized = stylized.clipByValue(0, 255).mul(1./255.);
        stylized = restoreCrop(stylized);
    }
    async function doStyleTransfer() {
        done = false;
        setTimeout(() => {
            transferStyle();
            done = true;
            setTimeout(() => {
                updateStylized();
            }, 25);
        }, 25);
    }

    async function updateStylized() {
        // console.log(stylized.shape);
        await tf.browser.toPixels(stylized, canvas);
    }

    async function setupWebcam() {
        video = document.getElementById('video');
        if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
            navigator.mediaDevices.getUserMedia({ video: {width: expW, height: expH} }).then(function(stream) {
                video.srcObject = stream;
                video.play();
                globalStream = stream;
            });
        }

    }
    async function snapImage() {
        let imgInput = document.getElementById('img-input');
        let vid = document.getElementById('video');
        var canvas = document.createElement('canvas');
        canvas.width = vid.videoWidth;
        canvas.height = vid.videoHeight;
        // canvas.width = expW;
        // canvas.height = expH;
        let context = canvas.getContext("2d");
        context.drawImage(vid, 0, 0, vid.videoWidth, vid.videoHeight);
        let dataURL = canvas.toDataURL('image/jpeg');
        imgInput.src = dataURL;
        imgInput.onload = () => {
            URL.revokeObjectURL(imgInput.src);
            updateContent();
        }

        // let content_canv = document.getElementById('img-input');    
        // let context = content_canv.getContext("2d");
        // let vid = document.getElementById('video');
        // context.drawImage(vid, 0, 0, W, H);
        // updateContent();

        // await getImages();
        // await transferStyle();
        // updateStylized();


    }
    function selectStyle(id) {
        selected_style = id;
        // setTimeout(async() => {
        style_feat = tf.tidy(() => {
            let style = tf.browser
                        .fromPixels(document.getElementById('style-'+id))
                        .reverse(-1)
                        .resizeBilinear([W, H])
                        .reshape([1, W, H, 3])
                        .cast('float32');
        
            return encoder.predict(style);
            // return style_feat

        })
        // }, 250);
    }

    onMount(async() => {
        changingStyles = true;
        // setupWebcam();
        await loadModels();
        await updateContent();
        await selectStyle(0);
        // console.log(tf.getBackend());
        // exportStyles();
        changingStyles = false;
    });

</script>

<Container>
    <div class='container'>
    <Row class='row' cols={{ md: 2, sm: 1 }}>
        <Col>
            <p>Laden Sie ein Bild hoch:</p>
            <label>Bild auswählen
                <input type="file" accept="image/*" id="content-input" on:change={updateInput} style="display: none;"/>
            </label>
        </Col>

        <Col>
            <div id='cam-col'>
            <p>oder nutzen Sie Ihre Webcam:</p>
            <div style="display: flex; flex-direction: row; justify-content: center;">
                <button
                    id="toggle"
                    on:click={toggleVid}
                    >
                    Webcam
                    {videoPlaying ? "ausschalten" : "einschalten"}
                </button>
                <button
                    id="snap"
                    on:click={snapImage}
                    style={videoPlaying ? "" : "display: none;"}
                >Bild aufnehmen</button>
            </div>
            <div id="video-container" style={videoPlaying ? "" : "display: none;"}>
                <!-- svelte-ignore a11y-media-has-caption -->
                <video id="video" width={expW} height={expH} on:click={toggleVid}></video>
            </div>
            </div>
        </Col>
    </Row>
    <Row class='row' cols={{ md: 2, sm: 1 }}>
        <Col>
            <div id='input-col'>
                <p>Ihr Original:</p>

                <img id="img-input" src={defaultContent}  crossorigin='anonymous' alt="content"/>

                <button
                    id="style"
                    on:click={doStyleTransfer} 
                >Restyle</button>
            </div>
        </Col>

        <Col>
            <div id='style-col'>
                <p>KI Restyle:</p>

                {#if !done}
                    <div class="spinner-container">
                        <Spinner />
                    </div>
                {:else}
                    <canvas id="canvas" width={expW} height={expH}></canvas>
                {/if}

                {#if stylized}
                    <button
                        id="download"
                        on:click={downloadImage}
                    >Bild herunterladen</button>
                {/if}
            </div>
        </Col>
    </Row>
    </div>
</Container>










    <!-- <Row> -->
        <!-- <div>
            Stylized image:
        </div>
        <Col xs="4">
            {#if !done}
                <div class="spinner-container">
                    <Spinner />
                </div>
            {:else} -->
                <!-- <canvas id="canvas" width={expW} height={expH}></canvas> -->
            <!-- {/if}
        </Col>
        <Col xs="4"> -->
            <!-- <button
                id="style"
                on:click={doStyleTransfer}>Style</button>
            {#if stylized}
            <button
                id="download"
                on:click={downloadImage}
                >Download</button>
            {/if} -->
        <!-- </Col>
        <Col xs="4">
            {#if changingStyles}
            <Modal isOpen={true}>
                <div class="spinner-container">
                    Loading...
                    <Spinner />
                </div>
            </Modal>
            {/if}
        </Col> -->
    <!-- </Row> -->
    <!-- <Row>
        <div>
            Content:
        </div>
    </Row> -->
    <!-- <Row> -->
    <!-- svelte-ignore a11y-missing-attribute -->
    <!-- <canvas id="content" width={W} height={H} src='imgs/avril_cropped.jpg'></canvas> -->
        <!-- <Col xs="4"> -->
            <!-- <canvas id="content" width={W} height={H}></canvas> -->
        <!-- </Col>
        <Col xs="4"> -->
            <!-- <input type="file" accept="image/*" id="content-input" on:change={updateInput} />
            <img id="img-input" src={defaultContent}  crossorigin='anonymous'/> -->
        <!-- </Col>
        <Col xs="4"> -->
            <!-- <div class="vid-container">
                <div>
            <button
                id="snap"
                on:click={snapImage}
                >snap</button>
            <button
                id="toggle"
                on:click={toggleVid}
                >
                {videoPlaying ? "disable" : "enable"}
                webcam
            </button>
            <div> -->
                <!-- svelte-ignore a11y-media-has-caption -->
                <!-- <video id="video" width={expW} height={expH} on:click={toggleVid}></video>
            </div> -->
        <!-- </Col>
    </Row> -->

<Container>
    <div class='container'>
    <Row class='row'>
        <p>
            Waehlen Sie einen neuen Style für Ihr Bild aus:
        </p>
    </Row>
    <Row class='row' cols={{ lg: 3, md: 2, sm: 2, xs: 1 }}>
    {#each STYLES.slice(0, 12) as style, i }
        <Col>
            <div class="top-buffer">
                <img id={"style-"+i} class:selected={i===selected_style} width={expW} height={expH} on:click={() => selectStyle(i)} src={style} crossorigin='anonymous' alt='style-{i}'/>
            </div>
        </Col>
    {/each}
    </Row>
    </div>
</Container>

<style>
    .selected {
        outline: 9px solid red;
    }
    .top-buffer {
        margin-top: 20px;
        margin-bottom: 20px;
        width: 196px;
    }
    .top-buffer img {
        width: 100%;
        height: 100%;
    }
    #img-input {
        width: 256px;
        /* width: 256px; */
        align-self: center;
        /* height: 256px; */
        /* object-fit: cover; */
    }
    #style, #download, #toggle, #snap {
        display: inline-block;
        padding: 10px;
        width: fit-content;
        margin-top: 10px;
        align-self: center;
    }
    .spinner-container {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 256px;
        height: 256px;
        align-self: center;
    }
    #video-container {
        align-self: center;
        justify-self: center;
        margin-top: 15px;
    }
    label, button {
        display: inline-block;
        padding: 10px;
        margin: 1px;
    }
    #input-col, #style-col {
        margin-top: 40px;
        margin-bottom: 40px;
    }
    #cam-col, #input-col, #style-col {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-items: center;
        /* margin-top: 25px; */
    }
    #canvas {
        width: 256px;
        /* width: 256px; */
        align-self: center;
    }
    .container {
        /* margin-left: 80px;
        margin-right: 80px; */
    }
    .row {
        margin-top: 25px;
    }
</style>